import { defineMessages } from '../define';

/** Экран настроек. */
export const pagesSettings = defineMessages({
  ru: {
    'settingsPage.title': 'Настройки',
    'settingsPage.baseCurrency': 'Базовая валюта',
    'settingsPage.baseCurrencyHint': 'В базовой валюте считаются лимиты, итоги и остаток. Прошлые периоды остаются в той валюте, в которой велись.',
    'settingsPage.rollover': 'Перенос остатка',
    'settingsPage.rolloverHint': 'Неизрасходованный остаток конверта прибавляется к лимиту следующего периода. Иначе каждый период начинается с нуля. Перенос считается при создании нового периода, текущий не пересчитывается.',
    'settingsPage.cycleStart': 'Начало периода',
    'settingsPage.cycleStartAria': 'День начала периода',
    'settingsPage.cycleDayMonth': '1-е (месяц)',
    'settingsPage.cycleDay': (p: { day: number }) => `${p.day}-е число`,
    'settingsPage.cycleHint': 'Период начинается в этот день: при 25-м «январь» длится с 25 января по 24 февраля. Удобно, когда зарплата приходит не 1-го числа.',
    'settingsPage.cycleShortMonth': 'В коротком месяце 29–31-е сдвигается к последнему дню.',
    'settingsPage.confirmCalendar': 'период снова станет календарным месяцем',
    'settingsPage.confirmWindow': (p: { day: number }) => `период будет считаться с ${p.day}-го числа по ${p.day - 1}-е следующего месяца`,
    'settingsPage.confirmText': (p: { window: string }) => `Начало периода: ${p.window}. Прошлые периоды и траты будут пересобраны, суммы в них изменятся.`,
    'settingsPage.confirmTitle': 'Сменить начало периода',
    'settingsPage.confirmOk': 'Пересчитать',
    'settingsPage.rate': 'Курс НБРБ',
    'settingsPage.rateStale': 'устарел',
    'settingsPage.rateUnavailable': (p: { error: string }) => `Курс недоступен: ${p.error}`,
    'settingsPage.rateOn': (p: { date: string }) => `на ${p.date}`,
    'settingsPage.rateStaleHint': 'Свежий курс получить не удалось, показан последний известный.',
    'settingsPage.rateNote': 'Курс фиксируется в каждой трате в момент ввода, поэтому прошлые суммы не меняются задним числом.',
  },
  en: {
    'settingsPage.title': 'Settings',
    'settingsPage.baseCurrency': 'Base currency',
    'settingsPage.baseCurrencyHint': 'Limits, totals and balance are calculated in the base currency. Past periods stay in the currency they were kept in.',
    'settingsPage.rollover': 'Roll over balance',
    'settingsPage.rolloverHint': "An envelope's unspent balance is added to next period's limit. Otherwise every period starts from zero. The rollover is calculated when a new period is created; the current one is not recalculated.",
    'settingsPage.cycleStart': 'Period start',
    'settingsPage.cycleStartAria': 'Period start day',
    'settingsPage.cycleDayMonth': '1st (calendar month)',
    'settingsPage.cycleDay': (p: { day: number }) => `${ordinal(p.day)} of the month`,
    'settingsPage.cycleHint': 'The period starts on this day: with the 25th, "January" runs from January 25 to February 24. Handy when your salary does not arrive on the 1st.',
    'settingsPage.cycleShortMonth': 'In shorter months the 29th to 31st move to the last day.',
    'settingsPage.confirmCalendar': 'the period will be a calendar month again',
    'settingsPage.confirmWindow': (p: { day: number }) => `the period will run from the ${ordinal(p.day)} to the ${ordinal(p.day - 1)} of the next month`,
    'settingsPage.confirmText': (p: { window: string }) => `Period start: ${p.window}. Past periods and expenses will be rebuilt, and their totals will change.`,
    'settingsPage.confirmTitle': 'Change period start',
    'settingsPage.confirmOk': 'Recalculate',
    'settingsPage.rate': 'NBRB rate',
    'settingsPage.rateStale': 'outdated',
    'settingsPage.rateUnavailable': (p: { error: string }) => `Rate unavailable: ${p.error}`,
    'settingsPage.rateOn': (p: { date: string }) => `as of ${p.date}`,
    'settingsPage.rateStaleHint': 'Could not get a fresh rate, showing the last known one.',
    'settingsPage.rateNote': 'The rate is fixed in each expense when it is entered, so past amounts never change retroactively.',
  },
  be: {
    'settingsPage.title': 'Налады',
    'settingsPage.baseCurrency': 'Базавая валюта',
    'settingsPage.baseCurrencyHint': 'У базавай валюце лічацца ліміты, вынікі і рэшта. Мінулыя перыяды застаюцца ў той валюце, у якой вяліся.',
    'settingsPage.rollover': 'Перанос рэшты',
    'settingsPage.rolloverHint': 'Невыдаткаваная рэшта канверта дадаецца да ліміту наступнага перыяду. Інакш кожны перыяд пачынаецца з нуля. Перанос лічыцца пры стварэнні новага перыяду, бягучы не пералічваецца.',
    'settingsPage.cycleStart': 'Пачатак перыяду',
    'settingsPage.cycleStartAria': 'Дзень пачатку перыяду',
    'settingsPage.cycleDayMonth': 'з 1 чысла (месяц)',
    'settingsPage.cycleDay': (p: { day: number }) => `з ${p.day} чысла`,
    'settingsPage.cycleHint': 'Перыяд пачынаецца ў гэты дзень: пры 25 чысле «студзень» доўжыцца з 25 студзеня па 24 лютага. Зручна, калі заробак прыходзіць не 1 чысла.',
    'settingsPage.cycleShortMonth': 'У кароткім месяцы 29–31 чысло зрушваецца на апошні дзень.',
    'settingsPage.confirmCalendar': 'перыяд зноў стане каляндарным месяцам',
    'settingsPage.confirmWindow': (p: { day: number }) => `перыяд будзе лічыцца з ${p.day} чысла па ${p.day - 1} чысло наступнага месяца`,
    'settingsPage.confirmText': (p: { window: string }) => `Пачатак перыяду: ${p.window}. Мінулыя перыяды і траты будуць перабудаваны, сумы ў іх зменяцца.`,
    'settingsPage.confirmTitle': 'Змяніць пачатак перыяду',
    'settingsPage.confirmOk': 'Пералічыць',
    'settingsPage.rate': 'Курс НБРБ',
    'settingsPage.rateStale': 'састарэў',
    'settingsPage.rateUnavailable': (p: { error: string }) => `Курс недаступны: ${p.error}`,
    'settingsPage.rateOn': (p: { date: string }) => `на ${p.date}`,
    'settingsPage.rateStaleHint': 'Не ўдалося атрымаць свежы курс, паказаны апошні вядомы.',
    'settingsPage.rateNote': 'Курс фіксуецца ў кожнай траце ў момант уводу, таму мінулыя сумы заднім чыслом не мяняюцца.',
  },
});

/** 1st, 2nd, 3rd, 4th... */
function ordinal(n: number): string {
  const suffix = { one: 'st', two: 'nd', few: 'rd', other: 'th' } as Record<string, string>;
  return `${n}${suffix[new Intl.PluralRules('en-US', { type: 'ordinal' }).select(n)] ?? 'th'}`;
}
